export const baseUrl = 'https://api.vat.e-bit.biz'
// export const baseUrl = 'http://127.0.0.1:8000'